import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { AuthenticateUserState } from '../store/authenticate-user.state';
import { REDIRECT_INSPECTION } from '../../shared/constants';

export const UnauthorizedGuard: CanActivateFn = (_route, _state) => {
  const store = inject(Store);
  const router = inject(Router);

  const isAuthenticated = store.selectSnapshot(
    AuthenticateUserState.getIsAuthenticated,
  );

  if (isAuthenticated) {
    // Redirect authenticated user back to previous URL if exists, else dashboard
    router.navigateByUrl(REDIRECT_INSPECTION);
    return false;
  }

  // Not authenticated → allow /unauthorized to be displayed
  return true;
};
